import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import Button from "Components/Button";
import Card from "Components/Card";
import { useContext } from "react";
import { Wrapper } from "./Hiring.styled";
const Hiring = () => {
  const { config } = useContext<publicationTypes>(PublicationContext);
  const handleClick = () => {
    const url = `https://recruiters.new-job-today.co.uk/`;
    window.open(url, "_blank");
  };

  return (
    <Card title="Are you hiring?">
      <Wrapper>
        <div className="actions">
          <p>
            Upload your jobs in minutes and get applications delivered straight
            to your inbox.
          </p>
          <div className="button_wrapper">
            <Button handleClick={handleClick} fullwidth buttonStyles="primary">
              Post your JOB
            </Button>
          </div>
        </div>
        <span>
          Or call our team on &nbsp;
          {config && config.jobs_number && config.jobs_number}
        </span>
      </Wrapper>
    </Card>
  );
};

export default Hiring;
